(function() {
    // 1. 타입
    // .module-type1 : 케어솔루션_제품모튤
    // .module-type2 : 케어십_유상제품 모듈
    // .module-type3 : 케어십_보유제품 모듈
    // .module-type4 : 케어십_용역제품 모듈

    // BTOCSITE-91168 [웹앱 접근성 개선활동] 서비스구독> (케어십, 정기배송/회수세척)
    var _listItemTemplate = 
        '<li class="item" tabindex="0">'+
        '   <div class="prd-care-vertical {{moduleType}}">'+
        '       {{#if moduleType == "module-type1" || moduleType == "module-type2" || moduleType == "module-type5"}}<a href="{{modelUrlPath}}" class="link_product_detail">{{/if}}'+
        '           <div class="img-wrap">'+
        '               <img src="{{modelImg}}" alt="">'+
        '           </div>'+
        '           <div class="txt-wrap">'+
        '           {{#if moduleType == "module-type3"}}'+
        '               <div class="flag-wrap"><span class="flag">보유제품</span></div>'+
        '           {{/if}}'+
        '               <p class="tit"><span class="blind">제품 디스플레이 네임</span>{{#raw userFriendlyName}}</p>'+
        '               <p class="code"><span class="blind">제품 코드</span>{{modelName}}</p>'+
        '           </div>'+
        '       {{#if moduleType == "module-type1" || moduleType == "module-type2" || moduleType == "module-type5"}}</a>{{/if}}'+
        '       <div class="info-wrap">'+
        '       {{#if moduleType == "module-type4"}}'+
        '           <p class="code-txt">{{modelDescription}}</p>'+
        '       {{/if}}'+

        '       {{#if purchaseInfo != null && purchaseInfo != undefined && purchaseInfo != ""}}'+
        '           <div class="txt-info">'+
        '           {{#each item in purchaseInfo}}'+
        '               <dl>'+
        '                   <dt>{{item.title}}</dt>'+
        '                   <dd>{{item.date}}</dd>'+
        '               </dl>'+
        '           {{/each}}'+
        '           </div>'+
        '       {{/if}}'+
        '           <div class="opt-info">'+
        '           {{#if siblingColors.length > 0}}'+
        '               <dl {{#if siblingColors.length == 1}}class="disabled"{{/if}}>'+
        '                   <dt>색상</dt>'+
        '                   <dd>'+
        '                       <div class="sort-select-wrap">'+
        '                           <select class="ui_selectbox" id="colorSet-{{modelId}}" title="색상 선택" data-sibling-type="siblingColors" {{#if siblingColors.length == 1}}disabled{{/if}}>'+
        '                           {{#each item in siblingColors}}'+
        '                               <option data-model-id="{{item.modelId}}"'+
                                                    ' data-group-id="{{item.siblingGroupCode}}"'+
                                                    ' value="{{item.siblingCode}}"'+
                                                    '{{#if selectColorID==item.siblingCode}} selected{{/if}}>{{item.siblingValue}}</option>'+
        '                           {{/each}}'+
        '                           </select>'+
        '                       </div>'+
        '                   </dd>'+
        '               </dl>'+
        '           {{/if}}'+
        '           {{#if siblingFee.length > 0}}'+
        '               <dl {{#if siblingFee.length == 1}}class="disabled"{{/if}}>'+
        '                   <dt>가입비</dt>'+
        '                   <dd>'+
        '                       <div class="sort-select-wrap">'+
        '                           <select class="ui_selectbox" id="feeSet-{{modelId}}" title="가입비 선택" data-sibling-type="siblingFee" {{#if siblingFee.length == 1}}disabled{{/if}}>'+
        '                           {{#each item in siblingFee}}'+
        '                               <option value="{{item.siblingCode}}"{{#if selectFeeID==item.siblingCode}} selected{{/if}}>{{item.siblingValue}}</option>'+
        '                           {{/each}}'+
        '                           </select>'+
        '                       </div>'+
        '                   </dd>'+
        '               </dl>'+
        '           {{/if}}'+
        '           {{#if siblingUsePeriod.length > 0}}'+
        '               <dl {{#if siblingUsePeriod.length == 1}}class="disabled"{{/if}}>'+
        '                   <dt>의무사용</dt>'+
        '                   <dd>'+
        '                       <div class="sort-select-wrap">'+
        '                           <select class="ui_selectbox" id="usePeriodSet-{{modelId}}" title="의무사용 선택" data-sibling-type="siblingUsePeriod" {{#if siblingUsePeriod.length == 1}}disabled{{/if}}>'+
        '                           {{#each item in siblingUsePeriod}}'+
        '                               <option value="{{item.siblingCode}}"{{#if selectUserPeriodID==item.siblingCode}} selected{{/if}}>{{item.siblingValue}}</option>'+
        '                           {{/each}}'+
        '                           </select>'+
        '                       </div>'+
        '                   </dd>'+
        '               </dl>'+
        '           {{/if}}'+
        '           {{#if siblingVisitCycle.length > 0}}'+
        '               <dl {{#if siblingVisitCycle.length == 1}}class="disabled"{{/if}}>'+
        '                   <dt>방문주기</dt>'+
        '                   <dd>'+
        '                       <div class="sort-select-wrap">'+
        '                           <select class="ui_selectbox" id="visiSet-{{modelId}}" title="방문주기 선택" data-sibling-type="siblingVisitCycle" {{#if siblingVisitCycle.length == 1}}disabled{{/if}}>'+
        '                           {{#each item in siblingVisitCycle}}'+
        '                               <option value="{{item.siblingCode}}"{{#if selectVisitCycleID==item.siblingCode}} selected{{/if}}>{{item.siblingValue}}</option>'+
        '                           {{/each}}'+
        '                           </select>'+
        '                       </div>'+
        '                   </dd>'+
        '               </dl>'+
        '           {{/if}}'+
		'           {{#if typeof siblingSvcType !== "undefined" && siblingSvcType.length > 0}}'+        
        '               <dl {{#if siblingSvcType.length == 1}}class="disabled"{{/if}}>'+
        '                   <dt>서비스타입</dt>'+
        '                   <dd>'+
        '                       <div class="sort-select-wrap">'+
        '                           <select class="ui_selectbox" data-combo-id="5" id="svcTypeSet-{{modelId}}" title="서비스타입선택" data-sibling-type="siblingSvcType" {{#if siblingSvcType.length == 1}}disabled{{/if}}>'+
        '                           {{#each item in siblingSvcType}}'+
        '                               <option value="{{item.siblingCode}}"{{#if selectSvcTypeCd==item.siblingCode}} selected{{/if}}>{{item.siblingValue}}</option>'+
        '                           {{/each}}'+
        '                           </select>'+
        '                       </div>'+
        '                   </dd>'+
        '               </dl>'+
        '           {{/if}}'+  
        '           </div>'+
        '       {{#if priceInfo != null && priceInfo != undefined && priceInfo != ""}}'+
        '           <div class="txt-info price-info">'+
        '           {{#each item in priceInfo}}'+
        '               <dl>'+
        '                   <dt>{{item.title}}</dt>'+
        '                   <dd>{{item.price}}원</dd>'+
        '               </dl>'+
        '           {{/each}}'+
        '           </div>'+
        '       {{/if}}'+
        '       <div class="price-wrap type2">'+
        '           <dl>'+
        '               <dt>이용 요금 <span class="small-text">(1년차 월 요금 기준)</span></dt>'+
        '               <dd>월 {{monthlyPrice}}원</dd>'+
        '           </dl>'+
        '       </div>'+
        '       </div>'+
        '   </div>'+
        '</li>';
    // BTOCSITE-24685 START
    var _isLanding = !!location.hash ? true : false; 
    
    var _landingCategoryMap = {
    		'#rental_water-purifiers' : {
                tab : 0,
                categoryName : '정수기'
            },
            '#rental_water-purifiers-refrigerator' : {
            	tab : 0,
            	categoryName : '얼음정수기냉장고'
            },
            '#rental_refrigerator' : {
            	tab : 0,
            	categoryName : '냉장고'
            },
    		'#rental_air-purifiers' : {
                tab : 0,
                categoryName : '공기청정기'
            },
    		'#rental_aerotower' : {
                tab : 0,
                categoryName : '에어로타워'
            },
    		'#rental_aero-furniture' : {
                tab : 0,
                categoryName : '에어로퍼니처'
            },
    		'#rental_air-conditioners' : {
                tab : 0,
                categoryName : '에어컨'
            },
    		'#rental_electric-stoves' : {
                tab : 0,
                categoryName : '전기레인지'
            },
    		'#rental_dishwashers' : {
                tab : 0,
                categoryName : '식기세척기'
            },
            '#rental_wash-tower' : {
            	tab : 0,
            	categoryName : '워시타워'
            },
    		'#rental_washing-machines' : {
                tab : 0,
                categoryName : '세탁기'
            },
    		'#rental_dryers' : {
                tab : 0,
                categoryName : '의류건조기'
            },
            '#rental_lg-styler' : {
                tab : 0,
                categoryName : '스타일러'
            },
    		'#rental_massage-chairs' : {
                tab : 0,
                categoryName : '안마의자'
            },
    		'#rental_lg-tiiun' : {
                tab : 0,
                categoryName : '식물생활가전'
            },
            '#rental_washtower' : {
                tab : 0,
                categoryName : '워시타워'
            },
            '#rental_kimchi-refrigerators' : {
            	tab : 0,
            	categoryName : '김치냉장고'
            },
    		'#careship_water-purifiers' : {
                tab : 1,
                categoryName : '정수기'
            },
    		'#careship_ice-water-purifiers-refrigerator' : {
                tab : 1,
                categoryName : '얼음정수기냉장고'
            },
    		'#careship_air-purifiers' : {
                tab : 1,
                categoryName : '공기청정기'
            },
    		'#careship_electronic-mask' : {
                tab : 1,
                categoryName : '전자식 마스크'
            },
    		'#careship_aerotower' : {
                tab : 1,
                categoryName : '에어로타워'
            },
    		'#careship_aero-furniture' : {
                tab : 1,
                categoryName : '에어로퍼니처'
            },
    		'#careship_air-conditioners' : {
                tab : 1,
                categoryName : '에어컨'
            },
    		'#careship_electric-stoves' : {
                tab : 1,
                categoryName : '전기레인지'
            },
    		'#careship_dishwashers' : {
                tab : 1,
                categoryName : '식기세척기'
            },
            '#careship_wash-tower' : {
            	tab : 1,
            	categoryName : '워시타워'
            },
    		'#careship_washing-machines' : {
                tab : 1,
                categoryName : '세탁기'
            },
    		'#careship_dryers' : {
                tab : 1,
                categoryName : '의류건조기'
            },
            '#careship_vacuum-cleaners' : {
                tab : 1,
                categoryName : '청소기'
            },
    		'#careship_lg-tiiun' : {
                tab : 1,
                categoryName : '식물생활가전'
            },
            '#careship_washtower' : {
                tab : 1,
                categoryName : '워시타워'
            },
            '#careship_kimchi-refrigerators' : {
            	tab : 1,
            	categoryName : '김치냉장고'
            },
			'#whatisRental' : {
                tab : 0
            },
			'#whatisCareship' : {
                tab : 1
            }
        };
    // BTOCSITE-24685 END
    
    $(window).load(function(){
    	// BTOCSITE-24685 START
    	if (_isLanding && !!_landingCategoryMap[location.hash]){
    		// 렌탈 서비스 / 카테고리 서비스 선택
    	    var tabIndex = _landingCategoryMap[location.hash].tab;
    	    var targetCategoryName = _landingCategoryMap[location.hash].categoryName;
    	    
    	    if (location.hash == '#whatisRental' || location.hash == '#whatisCareship') {
    	    	$('.tabs-wrap.border-type.ui_why_tab.csn-tabs ul li:eq(' + tabIndex + ') a').trigger('click');
    	    } else {
    	    	var uitab = $('.tabs-wrap.border-type.ui_why_tab.csn-tabs').vcTab('instance');
        		uitab.select(tabIndex, true);
    	    }
    	    
    		var categoryTabList = '.csn-tab-contents.service-rental ul.tabs li a'; // 렌탈 카테고리 탭 List
    		
    		if (targetCategoryName) {
    			// 렌탈서비스 카테고리 선택
    			if (tabIndex == 1) {
    				categoryTabList = '.csn-tab-contents.service-careship ul.tabs li a';
    			}
    			// 카테고리 선택
				$(categoryTabList).each(function(index, element){
					
					var tabName = $(this).text().replace('선택됨', '');
					if (tabName == _landingCategoryMap[location.hash].categoryName) {
						$(this).trigger('click'); // 태그 위치까지 이동이 되지 않아 trigger 사용. 
					}
				})
    		}
    		_isLanding = false;
    	}
    	// BTOCSITE-24685 END
    });
    	
    $(window).ready(function() {
        var careWhyTab = {
            init: function() {
                var self = this;
                self.listData = {};
                self.visibleCount = 12;
                self.setting();
                self.bindEvents();
                
                //BTOCSITE-75537
                $('.ui_why_tab').on("tabinit", function(e, data){
                    if(localStorage.getItem("header_careship") === 'true'){
                         $('[href="#service-careship"]').trigger('click');
                    }
                    localStorage.removeItem("header_careship");
                });
            },

            setting: function() {
                var self = this;

                self.$contents = $('div.contents');
                self.$section = self.$contents.find('div.csn-section.section-serviceCareship');
                //카테고리탭
                self.$tab = self.$section.find('.ui_tab:eq(0)');
            },

            bindEvents: function() {
                var self = this;

                //카테고리탭 선택
                self.$tab.on("tabbeforechange", function(e, data){
                    var $a = $(this).find('li:eq('+data.selectedIndex+') a');
                    var categoryID = $a.attr('href').replace("#","");
                    self.requestProdList(categoryID);
                });

                //최초 선택시 카테고리탭 선택
                self.$tab.on("tabinit", function(e, data){
                    var categoryID = self.findSelectCategoryID();
                    self.requestProdList(categoryID);
                });

                var $list = self.$contents.find('div.tab-content .prd-list-wrap');
                $list.on('change', '.info-wrap select', function(e){
                    e.preventDefault();
                    self.changeItemOptions(this);
                });

                //더보기
                self.$contents.find('div.tab-content .btn-moreview').on('click',function(e){
                    self.moreAddProdList($(this).parents('div.tab-content'));
                });
            },

            findSelectCategoryID: function() {
                var self = this;
                var categoryId = null;
                var $a = self.$tab.find('li.on a');
                if($a.length > 0) {
                    var href = $a.attr('href');
                    if(href) {
                        categoryId = href.replace("#","");
                    }
                }
                return categoryId;
            },

            requestProdList: function(categoryID) {
                if(!categoryID) return;

                var self = this;
                var ajaxUrl = self.$contents.data('prodList');
                var param = {
                    "categoryID":categoryID,
                    "tabID":"1"
                }
                lgkorUI.requestAjaxData(ajaxUrl, param, function(result) {
                    var data = result.data;

                    var $div = $('#'+categoryID);
                    $div.removeData('page');
                    var $list_ul = $div.find('.prd-list-wrap >ul');
                    $list_ul.empty();
                    var productList = (data.productList && data.productList instanceof Array) ? data.productList : [];
                    self.listData[categoryID] = productList;

                    self.moreAddProdList($div);

                    var count = productList.length;
                    $div.find('>p.prd-list-count span em').text(vcui.number.addComma(count));
                    if(count > 0) {
                        $div.find('>div.prd-list-wrap').show();
                        $div.find('>p.prd-list-count').show();
                    } else {
                        $div.find('>div.prd-list-wrap').hide();
                        $div.find('>p.prd-list-count').hide();
                    }
                });
            },

            // BTOCSITE-91168 [웹앱 접근성 개선활동] 서비스구독> (케어십, 정기배송/회수세척)
            addListItem:function($targetList, listData) {
                var self = this;
                var lastIdx = $targetList.find(">li").length;
                if(listData) {
                    //console.log($targetList.find(">li").length)
                    listData.forEach(function(item, index) {
                        self.setSiblingCodeNumbering(item);
                        $targetList.append(vcui.template(_listItemTemplate, item));
                    });
                    $targetList.find(">li").eq(lastIdx).attr("tabindex","0")
                    $targetList.find(">li").eq(lastIdx).focus();
                }
            },

            setSiblingCodeNumbering:function(item){
                var key;
                for(key in item.siblingFee) item.siblingFee[key].siblingCode = item.siblingFee[key].siblingCode.toString();
                for(key in item.siblingUsePeriod) item.siblingUsePeriod[key].siblingCode = item.siblingUsePeriod[key].siblingCode.toString();
                for(key in item.siblingVisitCycle) item.siblingVisitCycle[key].siblingCode = item.siblingVisitCycle[key].siblingCode.toString();
 				if(typeof item.siblingSvcType !== "undefined" && item.siblingSvcType.length > 0){                    
                    for(key in item.siblingSvcType) item.siblingSvcType[key].siblingCode = item.siblingSvcType[key].siblingCode.toString();//BTOCSITE-11892  
                } 
            },

            selectBoxReinit:function($target){
                $target.find('.ui_selectbox').vcSelectbox().on('selectboxopen',function(e, sbox){
                    var dl = $(sbox).closest('dl');
                    if(!dl.hasClass('open')) dl.addClass('open');
                }).on('selectboxclose', function(e, sbox){
                    var dl = $(sbox).closest('dl');
                    if(dl.hasClass('open')) dl.removeClass('open');
                });
            },

            moreAddProdList:function($div) {
                var self = this;
                var categoryID = $div.attr("id");
                var $list_ul = $div.find('.prd-list-wrap >ul');

                var arr = self.listData[categoryID];
                var divPage = $div.data('page');

                var productList = arr ? arr : [];
                var page = divPage ? divPage + 1 : 1;
                $div.data("page",page);
                
                var startIndex = (page-1)*self.visibleCount;
                var endIndex = (page-1)*self.visibleCount + self.visibleCount;

                var moreList = productList.slice((page-1)*self.visibleCount,endIndex);
                if(moreList && moreList.length > 0) {
                    var startIndex = $list_ul.find('>li').length;
                    var count = moreList.length;
                    self.addListItem($list_ul, moreList);
                    var $li = $list_ul.find('>li').slice(startIndex,startIndex+count);
                    self.selectBoxReinit($li);
                }

                var checkCount = $list_ul.find('>li').length;
                if(checkCount < productList.length) {
                    $div.find('.btn-moreview').css('display','block');
                } else {
                    $div.find('.btn-moreview').css('display','none');
                }
            },

            getOptionData:function(item){
                var optgroup = $(item).closest('.prd-care-vertical').find('.info-wrap .opt-info')
                var optdata = {};
                var optstring = [];
                optgroup.children().each(function(idx, opt){
                    var selectItem = $(opt).find('.ui_selectbox').vcSelectbox('instance');
                    var selectValue = selectItem.value();
                    var selectName = selectItem.text();
                    var siblingType = selectItem.$el.data('siblingType');
        
                    var optblock = $(opt).find('.ui_selectbox').find('option').filter("[value="+selectValue+"]");
                    var selectModelId = optblock.data("modelId");
                    var groupId = optblock.data("groupId");
                    
                    optdata[siblingType] = {
                        name: selectName,
                        value: selectValue,
                        modelId: selectModelId,
                        groupId: groupId
                    }
                });

                return {
                    optdata: optdata,
                    optstring: optstring
                };
            },

            //옵션 변경 시...
            changeItemOptions:function(item){
                var self = this;
                var idx = $(item).parents('li.item').index();
                var optionData = self.getOptionData(item);
                var siblingType = $(item).data('siblingType');
                if(siblingType == "siblingColors"){
                    self.setChangeColorChip(idx, optionData.optdata);
                } else{
                    self.setChangeOptionChip(idx, optionData.optdata)
                }
            },

            //색상 옵션 변경...
            setChangeColorChip:function(idx, optdata){
                var self = this;
                var categoryID = self.findSelectCategoryID();
                var _currentItemList = self.listData[categoryID];
                var _currentObj = _currentItemList[idx];

                var param = {
                    "tabID": "1",
                    "modelID": optdata.siblingColors.modelId,
                    "colorCd": optdata.siblingColors.value,
                    "siblingGroupCd": optdata.siblingColors.groupId,
                    "rtModelSeq": _currentObj.rtModelSeq,
                    "blockID": idx
                }
                var ajaxUrl = self.$contents.data('colorModel');

                lgkorUI.requestAjaxData(ajaxUrl, param, function(result){
                    var data = result.data;

                    _currentObj.rtModelSeq = data.rtModelSeq;
                    _currentObj.monthlyPrice = data.monthPrice;

                    var $div = $('#'+categoryID);
                    var $list_ul = $div.find('.prd-list-wrap >ul');

                    self.setSiblingCodeNumbering(data);
                    for(var key in data){                
                        _currentObj[key] = data[key];
                    }

                    var deleteItem = $list_ul.find('li.item:eq('+idx+')');

                    deleteItem.after(vcui.template(_listItemTemplate, data));
                    deleteItem.remove();

                    var $li = $list_ul.find('li.item:eq('+idx+')');
                    self.selectBoxReinit($li);
                });
            },

            //색상 외 옵션 변경...
            setChangeOptionChip:function(idx, optdata){
                var self = this;
                var categoryID = self.findSelectCategoryID();
                var _currentItemList = self.listData[categoryID];
                var _currentObj = _currentItemList[idx];

                var param = {
                    "tabID": "1",
                    "modelID": _currentObj.modelId,//BTOCSITE-36318 [렌탈/케어]렌탈/케어십 소개 > 케어십 서비스 방문주기 오류건
                    "rtModelSeq": _currentObj.rtModelSeq,
                    "feeCd": optdata.siblingFee && optdata.siblingFee.value ? optdata.siblingFee.value : '',
                    "usePeriodCd": optdata.siblingUsePeriod && optdata.siblingUsePeriod.value ? optdata.siblingUsePeriod.value : '',
                    "visitCycleCd": optdata.siblingVisitCycle && optdata.siblingVisitCycle.value ? optdata.siblingVisitCycle.value : '',
					"svcTypeCd"  : optdata.siblingSvcType && optdata.siblingSvcType.value ? optdata.siblingSvcType.value : '',
                    "blockID": idx
                }
                var ajaxUrl = self.$contents.data('priceStatus');
                lgkorUI.requestAjaxData(ajaxUrl, param, function(result){
                    var data = result.data;

                    _currentObj.rtModelSeq = data.rtModelSeq;
                    _currentObj.monthlyPrice = data.monthPrice;

                    var $div = $('#'+categoryID);
                    var $list_ul = $div.find('.prd-list-wrap >ul');

                    $list_ul.find('li.item:eq('+idx+')').find('.price-wrap dl dd').text("월 " + data.monthPrice + "원");
                    
                    //BTOCSITE-36318 [렌탈/케어]렌탈/케어십 소개 > 케어십 서비스 방문주기 오류건 START
                    var $prodListContainer = $('.prd-list-wrap');
                    var blockID = result.data.blockID;
                    var listBlock = $prodListContainer.find('> ul.inner > li.item').eq(blockID);
                	
                    if(typeof result.data.siblingSvcType !== "undefined" && result.data.siblingSvcType.length > 0){
                        var o = result.data.siblingSvcType;
                        var selectSvcType = Object.keys(o).reduce(function (previous, current) {
                            return o[previous].siblingCode > o[current].siblingCode ? previous:current;
                        });
                        selectSvcType = o[selectSvcType].siblingCode;
                    }
                    
                    if(typeof result.data.siblingSvcType !== "undefined" && result.data.siblingSvcType.length > 0){
                        
                        var list = result.data.siblingSvcType
                        var selectIdx = 0;
                        var selectId = result.data.selectSvcTypeCd;
                        var list = vcui.array.map(list, function(item, idx){
                            item['text'] =  item.siblingValue ;
                            item['value'] = item.siblingCode;

                            if(item.siblingCode == selectId) selectIdx = idx;
                            return item;
                        });
                        var selector = listBlock.find('select[data-sibling-type=siblingSvcType]');
                        selector.vcSelectbox('update', list).vcSelectbox('selectedIndex', result.data.selectSvcTypeCd, false);

                        // 20210720 BTOCSITE-2537 케어솔루션 > 금융리스 상품 판매, 자가관리 상품판매를 위한 개발
                        if(list.length === 1) {
                            selector.vcSelectbox('disabled',true);
                            selector.closest('dl').addClass("disabled");
                        } else {
                            selector.vcSelectbox('disabled',false);
                            selector.closest('dl').removeClass("disabled");
                        }
                        
                    }

                    //BTOCSITE-36318 [렌탈/케어]렌탈/케어십 소개 > 케어십 서비스 방문주기 오류건 END
                    
                });
            },
            
        }

        careWhyTab.init();
    });
})();



$(function(){

    if(vcui.detect.isIOS){
        $('.csn-ars-bottom').hide();
    }
    vcui.require(['ui/tab','ui/sticky'], function () {        
        $('.ui_why_tab').on('tabchange', function(e,data){
            var $content = $(data.content);
            var stickyHeight = $(this).parents('.ui_sticky').height();
            var top = $content.offset().top - parseInt($content.css('padding-top'));
            //$('html, body').scrollTop(top-stickyHeight);
            $('html, body').animate({scrollTop:top-stickyHeight});
            //$('.ui_sticky.sticky2').vcSticky("update");
            btnEventMore();
        }).vcTab();

        $('.ui_tab').each(function(){            
            $(this).on('tabchange', function(){
                var stickyHeight1 = $(this).parents('.ui_sticky').height() + $('.ui_sticky.sticky1').height();
                var top1 = $(this).parents('.csn-section').offset().top;
                //console.log(top1, $(this).parents('.ui_sticky').height(), $('.ui_sticky.sticky1').height())
                $('html, body').scrollTop(top1-stickyHeight1 + 100);
                //$('html, body').animate({scrollTop:top1-stickyHeight1});
                btnEventMore();
            }).vcTab();
        });

        $('.ui_sticky.sticky2').vcSticky({
            //marginTop : $('.ui_sticky.sticky1').outerHeight(),
            stickyContainer : ".csn-tab-contents"
        });

/*
        $(window).on("scroll", function(){
            stickySetting();
        });
        function stickySetting() {
            $('.ui_sticky.sticky2').each(function(){
                if($(this).hasClass("fixed")){
                    $(this).css("padding-top", $('.ui_sticky.sticky1').outerHeight());
                    console.log(0)
                } else {
                    $(this).css("padding-top", "0")
                    console.log(1)
                }
            });
        }
*/
        
        //2021-04-29 정승우
        //딱히 수정요청도 없었고 페이지에서 수정하는것이 좋지만 철수 관계로 수정요청할 타이밍이 안되니
        //떠나기전에 스크립트로 일단 처리해주고 감.
        //크롬에서 유튜브 iframe으로 요청할시 origin에러가 날경우 처리.
        //특히 iframe에서 src를 교체하는것이 아니고 통째로 교체를 한 이유는
        //iframe의 history pushState 습성 떄문에 히스토리 백이 원하는대로 동작하지 않음
        
        var iframe = $('article div.youtube-box .video-box > iframe');
        iframe.each(function(idx, item){
            var obj = $(item);
            var src = obj.attr('src');
            src += ('?autohide=1&autoplay=0' +
            '&cc_load_policy=0&controls=1' +
            '&disablekb=1&enablejsapi=1' +
            '&fs=0&iv_load_policy=3' +
            '&modestbranding=1&rel=0' +
            '&showinfo=0&start=0' +
            '&widgetid=1' +
            '&origin=' + location.origin);

            changeIframeSrc(item,src);
        });

        function changeIframeSrc(iframe, src) {
            var frame = iframe.cloneNode();
            frame.src = src;
            iframe.parentNode.replaceChild(frame, iframe);
        };
        
    });

    $(".csn-tab-contents.service-careship .only-rental-show").each(function(){
        $(this).remove();                
    });

    $(".csn-tab-contents.service-careship .csn-icon-list.size1 > ul").each(function(){
        if($(this).children("li").size() == 3){
            $(this).addClass("type_nowrap");
        }
    });    

    // 더보기...
    $(".btn-event-more").on('click', function(e){
        e.preventDefault();

        var $span = $(this).find('span').eq(0);
        var toggleTxt = $(this).data('toggleTxt');
        var toggleConts = $(this).data('toggleConts');
        var toggleContsTop = $(this).data('toggleConts') + "_top";
        var txt = $span.text();
        $(this).data('toggleTxt', txt);

        if($(this).hasClass('fold')){
            $(this).removeClass('fold');
            $(this).parent().removeClass("on");
            $span.text(toggleTxt);
            $(toggleConts).each(function(){
                $(this).removeClass("on");                
            });
            $(toggleConts).eq(0).removeAttr("tabindex") //BTOCSITE-91168 [웹앱 접근성 개선활동] 서비스구독> (케어십, 정기배송/회수세척)
            //$('html,body').animate({scrollTop : $(toggleContsTop).offset().top});
        }else{
            $(this).addClass('fold');
            $(this).parent().addClass("on");
            $span.text(toggleTxt);
            $(toggleConts).each(function(){
                $(this).addClass("on");                
            });

            //BTOCSITE-91168 [웹앱 접근성 개선활동] 서비스구독> (케어십, 정기배송/회수세척)
            $(toggleConts).eq(0).attr("tabindex","0")
            $(toggleConts).eq(0).focus()

            //$('html,body').animate({scrollTop : $(toggleContsTop).offset().top - parseInt($(toggleContsTop).css("margin-top"))});
        }
    });

    function btnEventMore() {
        $(".btn-event-more").each(function(){
            /*
            var toggleConts = $(this).data('toggleConts');
            var txt = $span.text();
            $(this).data('toggleTxt', txt);
            */
            if($(this).hasClass("fold")){
                $(this).click();
                /*
                $(this).removeClass('fold');
                $(this).parent().removeClass("on");
                $(toggleConts).each(function(){
                    $(this).removeClass("on");                
                });
                */
            }
        });  
    }

    $(".animation-box .see-video").on('click', function(){
        $(this).closest(".animation-box").find("button[name='pause']").click();
    });

});
